import { render, staticRenderFns } from "./ghandleGoodsNum.vue?vue&type=template&id=02dce51a&scoped=true&"
import script from "./ghandleGoodsNum.vue?vue&type=script&lang=js&"
export * from "./ghandleGoodsNum.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02dce51a",
  null
  
)

export default component.exports